import { SvgIcon, SvgIconProps } from "@mui/material";

type IconProps = SvgIconProps & {
	size?: number;
};

export const GalleryIcon = ({ size = 20, ...props }: IconProps) => {
	return (
		<SvgIcon width={14} height={14} viewBox="0 0 14 14" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
				<path
					d="M7.95833 3.29162L7.965 3.29162M5.29167 11.2915L2.625 11.2915C2.09457 11.2915 1.58586 11.0808 1.21079 10.7057C0.835715 10.3306 0.625001 9.82195 0.625001 9.29152L0.625 2.62497C0.625 2.09454 0.835714 1.58584 1.21079 1.21078C1.58586 0.83571 2.09457 0.625 2.625 0.625L9.29167 0.624999C9.8221 0.624999 10.3308 0.835709 10.7059 1.21078C11.081 1.58584 11.2917 2.09454 11.2917 2.62497L11.2917 5.29159M0.625001 7.95822L3.29167 5.2916C3.91033 4.69627 4.673 4.69627 5.29167 5.2916L7.29167 7.29156L7.95833 6.62489C8.165 6.42623 8.38767 6.29357 8.61633 6.22757M10.2383 8.36486C10.3683 8.23485 10.5227 8.13172 10.6925 8.06136C10.8624 7.99101 11.0445 7.95479 11.2283 7.95479C11.4122 7.95479 11.5943 7.99101 11.7641 8.06136C11.934 8.13172 12.0883 8.23485 12.2183 8.36486C12.3483 8.49486 12.4515 8.6492 12.5218 8.81907C12.5922 8.98893 12.6284 9.17098 12.6284 9.35484C12.6284 9.5387 12.5922 9.72075 12.5218 9.89061C12.4515 10.0605 12.3483 10.2148 12.2183 10.3448L9.95833 12.6248L7.95833 12.6248L7.95833 10.6248L10.2383 8.36486Z"
					stroke="var(--primary-text-color)"
					stroke-width="1.25"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
};
